import {useEffect, useRef, useState} from 'react';

/**
 * Hook to observe cart drawer/notification active state
 * Used to show/hide the widget when cart is open/closed
 * @returns {boolean} isShowWidget
 */
export default function useCartDrawerObserver() {
  const cartRef = useRef(
    document.getElementById('cart-notification') ||
      document.getElementsByTagName('cart-drawer')[0] ||
      document.getElementById('CartDrawer')
  );

  const [isShowWidget, setIsShowWidget] = useState(
    cartRef.current
      ? ['active', 'drawer--is-open'].every(
          className => !cartRef.current.classList.contains(className)
        )
      : true
  );

  useEffect(() => {
    if (!cartRef.current) return;

    const observer = new MutationObserver(mutationList => {
      const hasAttributeChange = mutationList.some(mutation => mutation.type === 'attributes');
      if (hasAttributeChange) {
        setIsShowWidget(
          ['active', 'drawer--is-open'].every(
            className => !cartRef.current.classList.contains(className)
          )
        );
      }
    });

    observer.observe(cartRef.current, {attributes: true});

    return () => observer.disconnect();
  }, [cartRef]);

  return {isShowWidget};
}
